<template>
  <div class="app-documentacao">
    <!-- VERIFICA O STATUS DA PAGINA -->
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <!-- VERIFICA O STATUS DA PAGINA -->
    <template v-else>
      <div class="app-documentacao-body">
        <div class="app-documentacao-top">
          <!-- SETA O LOGO DO ROTINA FACIL -->
          <div style="text-align: left; margin-top: -100px; margin-bottom: 95px; padding-top: 10px; padding-left: 10px;">
            <a href='http://www.rotinafacil.com.br' target='_blank'><img src="/img/logo-white.png" style="margin-left: -25px; width: 150px"></a>
          </div>

          <!-- SETA O TITULO DA PAGINA -->
          <div class="titulo noselect">Como podemos ajudar?</div>

          <!-- SETA O INPUT DE BUSCA -->
          <input type="text" v-model="filtroBusca" placeholder="Digite sua pesquisa" :autofocus="$store.state.mobile === false && [ '', null, undefined ].indexOf($route.params.busca) !== -1" @keyup.enter="appDocumentacaoRealizarBusca" />

          <!-- SETA A PARTE DE A BUSCA DA TELA -->
          <RF-Filtro-Busca-Telas v-if="Object.keys(filtros).length >= 1"
            :data-time='time'
            :cpntTime='time'
            :cpntStatus='filtros.status'
            :cpntField='filtros.field'
            :cpntTitulo="'Filtrar documentação'"

            :cpntOnRealizaBusca='appDocumentacaoRealizarBusca'
            ref='filtros'
          ></RF-Filtro-Busca-Telas>
        </div>

        <!-- SETA O CONTEUDO DA PAGINA -->
        <div class="app-documentacao-conteudo">
          <!-- VERIFICA O STATUS DA PAGINA -->
          <template v-if='statusResposta !== ""'>
            <RF-Status :cpntStatus='statusResposta' :cpntTamanho='5'></RF-Status>
          </template>

          <!-- VERIFICA O STATUS DA PAGINA -->
          <template v-else>
            <!-- SETA A TELA DE DUVIDA NÃO ENCONTRADA -->
            <div v-if="dados.length === 0 && (Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1)" class="solicitar">
              <table>
                <tr>
                  <td colspan="2">
                    Nenhum registro encontrado para esta pesquisa.
                    <br/>
                    <br/>
                    Preencha abaixo o formulário, caso queira um vídeo explicando sua dúvida.
                    <br/>
                  </td>
                </tr>
                <tr class="campos">
                  <!-- NOME -->
                  <td>
                    <RF-Componente v-if="Object.keys(formulario.field.nome).length >= 1"
                      :data-time='time'
                      :cpntTamanho='formulario.field.nome.tamanho'
                      :cpntModelo='formulario.field.nome.tipo'
                      :cpntType='formulario.field.nome.type'
                      :cpntStatus='formulario.field.nome.status'
                      :cpntId='formulario.field.nome.id'
                      :cpntClassDivField='formulario.field.nome.classDivField'
                      :cpntNome='formulario.field.nome.nome'
                      :cpntValue='formulario.field.nome.value'
                      :cpntMask='formulario.field.nome.mask'
                      :cpntPlaceholder='formulario.field.nome.placeholder'
                      :cpntValueRef='formulario.field.nome.valueRef'
                      :cpntOptions='formulario.field.nome.options'
                      :cpntKeyValue='formulario.field.nome.keyValue'
                      :cpntKeyMostra='formulario.field.nome.keyMostra'
                      :cpntAutoComplete='formulario.field.nome.autocomplete'
                      :cpntDisabled='formulario.field.nome.disabled'
                      :cpntMostrar='formulario.field.nome.mostrar'
                      :cpntMensagem='formulario.field.nome.mensagem'
                      :cpntSelecioneNome='formulario.field.nome.selecioneNome'
                      :cpntSelecioneValue='formulario.field.nome.selecioneValue'
                      :cpntMensagemTipo='formulario.field.nome.mensagemTipo'
                      :cpntAdicinarOption='formulario.field.nome.adicinarOption'
                      :cpntMultiple='formulario.field.nome.multiple'
                      :cpntAllRegistro='formulario.field.nome.allRegistro'
                      :cpntExplica='formulario.field.nome.explica'
                      :cpntConfig='formulario.field.nome.config'
                      :cpntTabIndex='formulario.field.nome.tabIndex'
                      :cpntMaxLength='formulario.field.nome.maxLength'
                      :cpntOptionInicialNome='formulario.field.nome.optionInicialNome'
                      :cpntOptionInicialValue='formulario.field.nome.optionInicialValue'

                      :cpntOnChange='formulario.field.nome.onChange'
                      :cpntOnBlur='formulario.field.nome.onBlur'
                      :ref='formulario.field.nome.id'
                    ></RF-Componente>
                  </td>

                  <!-- TELEFONE -->
                  <td>
                    <RF-Componente v-if="Object.keys(formulario.field.telefone).length >= 1"
                      :data-time='time'
                      :cpntTamanho='formulario.field.telefone.tamanho'
                      :cpntModelo='formulario.field.telefone.tipo'
                      :cpntType='formulario.field.telefone.type'
                      :cpntStatus='formulario.field.telefone.status'
                      :cpntId='formulario.field.telefone.id'
                      :cpntClassDivField='formulario.field.telefone.classDivField'
                      :cpntNome='formulario.field.telefone.nome'
                      :cpntValue='formulario.field.telefone.value'
                      :cpntMask='formulario.field.telefone.mask'
                      :cpntPlaceholder='formulario.field.telefone.placeholder'
                      :cpntValueRef='formulario.field.telefone.valueRef'
                      :cpntOptions='formulario.field.telefone.options'
                      :cpntKeyValue='formulario.field.telefone.keyValue'
                      :cpntKeyMostra='formulario.field.telefone.keyMostra'
                      :cpntAutoComplete='formulario.field.telefone.autocomplete'
                      :cpntDisabled='formulario.field.telefone.disabled'
                      :cpntMostrar='formulario.field.telefone.mostrar'
                      :cpntMensagem='formulario.field.telefone.mensagem'
                      :cpntSelecioneNome='formulario.field.telefone.selecioneNome'
                      :cpntSelecioneValue='formulario.field.telefone.selecioneValue'
                      :cpntMensagemTipo='formulario.field.telefone.mensagemTipo'
                      :cpntAdicinarOption='formulario.field.telefone.adicinarOption'
                      :cpntMultiple='formulario.field.telefone.multiple'
                      :cpntAllRegistro='formulario.field.telefone.allRegistro'
                      :cpntExplica='formulario.field.telefone.explica'
                      :cpntConfig='formulario.field.telefone.config'
                      :cpntTabIndex='formulario.field.telefone.tabIndex'
                      :cpntMaxLength='formulario.field.telefone.maxLength'
                      :cpntOptionInicialNome='formulario.field.telefone.optionInicialNome'
                      :cpntOptionInicialValue='formulario.field.telefone.optionInicialValue'

                      :cpntOnChange='formulario.field.telefone.onChange'
                      :cpntOnBlur='formulario.field.telefone.onBlur'
                      :ref='formulario.field.telefone.id'
                    ></RF-Componente>
                  </td>
                </tr>
                <tr class="campos">
                  <!-- EMAIL -->
                  <td colspan="2">
                    <RF-Componente v-if="Object.keys(formulario.field.email).length >= 1"
                      :data-time='time'
                      :cpntTamanho='formulario.field.email.tamanho'
                      :cpntModelo='formulario.field.email.tipo'
                      :cpntType='formulario.field.email.type'
                      :cpntStatus='formulario.field.email.status'
                      :cpntId='formulario.field.email.id'
                      :cpntClassDivField='formulario.field.email.classDivField'
                      :cpntNome='formulario.field.email.nome'
                      :cpntValue='formulario.field.email.value'
                      :cpntMask='formulario.field.email.mask'
                      :cpntPlaceholder='formulario.field.email.placeholder'
                      :cpntValueRef='formulario.field.email.valueRef'
                      :cpntOptions='formulario.field.email.options'
                      :cpntKeyValue='formulario.field.email.keyValue'
                      :cpntKeyMostra='formulario.field.email.keyMostra'
                      :cpntAutoComplete='formulario.field.email.autocomplete'
                      :cpntDisabled='formulario.field.email.disabled'
                      :cpntMostrar='formulario.field.email.mostrar'
                      :cpntMensagem='formulario.field.email.mensagem'
                      :cpntSelecioneNome='formulario.field.email.selecioneNome'
                      :cpntSelecioneValue='formulario.field.email.selecioneValue'
                      :cpntMensagemTipo='formulario.field.email.mensagemTipo'
                      :cpntAdicinarOption='formulario.field.email.adicinarOption'
                      :cpntMultiple='formulario.field.email.multiple'
                      :cpntAllRegistro='formulario.field.email.allRegistro'
                      :cpntExplica='formulario.field.email.explica'
                      :cpntConfig='formulario.field.email.config'
                      :cpntTabIndex='formulario.field.email.tabIndex'
                      :cpntMaxLength='formulario.field.email.maxLength'
                      :cpntOptionInicialNome='formulario.field.email.optionInicialNome'
                      :cpntOptionInicialValue='formulario.field.email.optionInicialValue'

                      :cpntOnChange='formulario.field.email.onChange'
                      :cpntOnBlur='formulario.field.email.onBlur'
                      :ref='formulario.field.email.id'
                    ></RF-Componente>
                  </td>
                </tr>
                <tr class="campos">
                  <!-- DESCRICAO -->
                  <td colspan="2">
                    <RF-Componente v-if="Object.keys(formulario.field.descricao).length >= 1"
                      :data-time='time'
                      :cpntTamanho='formulario.field.descricao.tamanho'
                      :cpntModelo='formulario.field.descricao.tipo'
                      :cpntType='formulario.field.descricao.type'
                      :cpntStatus='formulario.field.descricao.status'
                      :cpntId='formulario.field.descricao.id'
                      :cpntClassDivField='formulario.field.descricao.classDivField'
                      :cpntNome='formulario.field.descricao.nome'
                      :cpntValue='formulario.field.descricao.value'
                      :cpntMask='formulario.field.descricao.mask'
                      :cpntPlaceholder='formulario.field.descricao.placeholder'
                      :cpntValueRef='formulario.field.descricao.valueRef'
                      :cpntOptions='formulario.field.descricao.options'
                      :cpntKeyValue='formulario.field.descricao.keyValue'
                      :cpntKeyMostra='formulario.field.descricao.keyMostra'
                      :cpntAutoComplete='formulario.field.descricao.autocomplete'
                      :cpntDisabled='formulario.field.descricao.disabled'
                      :cpntMostrar='formulario.field.descricao.mostrar'
                      :cpntMensagem='formulario.field.descricao.mensagem'
                      :cpntSelecioneNome='formulario.field.descricao.selecioneNome'
                      :cpntSelecioneValue='formulario.field.descricao.selecioneValue'
                      :cpntMensagemTipo='formulario.field.descricao.mensagemTipo'
                      :cpntAdicinarOption='formulario.field.descricao.adicinarOption'
                      :cpntMultiple='formulario.field.descricao.multiple'
                      :cpntAllRegistro='formulario.field.descricao.allRegistro'
                      :cpntExplica='formulario.field.descricao.explica'
                      :cpntConfig='formulario.field.descricao.config'
                      :cpntTabIndex='formulario.field.descricao.tabIndex'
                      :cpntMaxLength='formulario.field.descricao.maxLength'
                      :cpntOptionInicialNome='formulario.field.descricao.optionInicialNome'
                      :cpntOptionInicialValue='formulario.field.descricao.optionInicialValue'

                      :cpntOnChange='formulario.field.descricao.onChange'
                      :cpntOnBlur='formulario.field.descricao.onBlur'
                      :ref='formulario.field.descricao.id'
                    ></RF-Componente>
                  </td>
                </tr>
                <tr class="botoes" v-if="Object.keys(formulario.buttons).length >= 1">
                  <td colspan="2">
                    <RF-Button v-for='(button, index) in formulario.buttons'
                      :data-time='time'
                      :key='index'

                      :cpntStatus='button.status' 
                      :cpntId='button.id' 
                      :cpntTexto='button.texto' 
                      :cpntClass='button.class'
                      :cpntMostrar='button.mostrar'
                      :cpntTabIndex='button.tabIndex'

                      @onClickButton='button.onClick'
                    ></RF-Button>
                  </td>
                </tr>
              </table>
            </div>

            <!-- APRESENTA TODAS AS PERGUNTAS -->
            <template v-else>
              <!-- ({{ dados.length - 1 }}) -->
              <div v-for="(item, indexV) in dados" :key="item.id" class="celula">
                <!-- ({{ indexV }}) -->
                <table>
                  <tr>
                    <td class="pergunta" @click="appDocumentacaoMostrarResposta(indexV)">
                      <!-- SETA O ICONE -->
                      <span :key="'icone-' + indexV + '-' + time">
                        <svg class="fa fa-minus" v-if="item.mostrar === true"></svg>
                        <svg class="fas fa-plus" v-else></svg>
                      </span>

                      <!-- SETA O TITULO -->
                      <span v-html="item.assunto"></span>
                    </td>
                    <td class="copiar">
                      <div @click="appDocumentacaoCopiarLink(indexV)">
                        <svg class="far fa-copy" aria-hidden="true"></svg>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="[ '', null, undefined ].indexOf(item.mostrar) === -1" v-show="item.mostrar === true">
                    <td class="resposta" colspan="2">
                      <table>
                        <!-- SETA O PLAYER DO VIDEO -->
                        <tr>
                          <td colspan="2">
                            <video controls :ref="'video-' + indexV">
                              <source :src='item.link' type='video/webm;codecs="vp8,vorbis"'>
                            </video>
                          </td>
                        </tr>

                        <!-- SETA OS DADOS DO VIDEO -->
                        <tr>
                          <td>
                            Pacote: <span v-html="item.id_pac_nome"></span>
                          </td>
                          <td>
                            Data/Hora: <span v-html="item.created_at_ptbr"></span>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .app-documentacao > .rf-status {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: calc(-18px / 2);
    margin-left: calc(-82px / 2);
  }
    .app-documentacao > .app-documentacao-body {
      margin-left: -10px;
      padding-top: 15px;
    }
    .app-documentacao {
      width: 100%;
      min-height: 100%;
    }
    .app-documentacao > .app-documentacao-body > .app-documentacao-top {
      margin-top: 85px;
      text-align: center;
    }
      .app-documentacao > .app-documentacao-body > .app-documentacao-top > a > img {
        margin-bottom: 15px;
        text-align: left;
      }
    .app-documentacao > .app-documentacao-body > .app-documentacao-top > .titulo {
      font-size: 30px;
      font-weight: 300;
      line-height: 38px;
      margin-bottom: 15px;
      text-align: center;
      color: #337ab7;
    }
    .app-documentacao > .app-documentacao-body > .app-documentacao-top > input {
      width: 95%;
      max-width: 500px;
      line-height: 30px;
      background: #fff;
      border: 1px solid transparent;
      border-radius: 8px;
      padding: 2px 15px;
      border: 1px solid #2e6da4;
      margin-left: -15px;
    }

  @media only screen and (max-width: 560px) {
    .app-documentacao > .app-documentacao-body > .app-documentacao-top > input {
      max-width: calc(90% - 50px);
    }
  }

  .app-documentacao-conteudo {
    width: 100%;
    margin: 0px auto;
    margin-top: 15px;
    text-align: left;
    max-width: 900px;
  }
    .app-documentacao-conteudo > .celula {
      background: #fff;
      border-radius: 10px;
      padding: 15px;
      margin: 20px 10px;
      border: 1px solid #e9e9e9;

      -webkit-box-shadow: 10px 10px 10px -10px rgba(204,204,204,0.5);
      -moz-box-shadow: 10px 10px 10px -10px rgba(204,204,204,0.5);
      box-shadow: 10px 10px 10px -10px rgba(204,204,204,0.5);
    }
      .app-documentacao-conteudo > .celula > table {
        width: 100%;
      }
      .app-documentacao-conteudo > .celula > table > tr > td.copiar {
        width: 40px;
        text-align: right;
        cursor: pointer;
      }
        .app-documentacao-conteudo > .celula > table > tr > td.copiar > div {
          display: none;
        }
        .app-documentacao-conteudo > .celula:hover > table > tr > td.copiar > div {
          display: block;
        }
      .app-documentacao-conteudo > .celula > table > tr > td.pergunta {
        cursor: pointer;
      }
        .app-documentacao-conteudo > .celula > table > tr > td.pergunta > span > svg {
          margin-right: 5px;
        }

      .app-documentacao-conteudo > .celula > table > tr > td.resposta {
        padding-top: 10px;
      }
        .app-documentacao-conteudo > .celula > table > tr > td.resposta > table {
          width: 100%;
        }
          .app-documentacao-conteudo > .celula > table > tr > td.resposta > table > tr > td > video {
            width: 100%;
            max-width: 100%;
          }
          .app-documentacao-conteudo > .celula > table > tr > td.resposta > table > tr:last-child > td {
            vertical-align: top;
            padding: 5px 10px 0px;
            font-size: 15px;
            width: 50%;
          }
          .app-documentacao-conteudo > .celula > table > tr > td.resposta > table > tr:last-child > td:first-child {
            text-align: left;
          }
          .app-documentacao-conteudo > .celula > table > tr > td.resposta > table > tr:last-child > td:last-child {
            text-align: right;
          }
      .app-documentacao-conteudo > .solicitar {
        text-align: center;
        max-width: 590px;
        margin: 0px auto;
        background: #e9e9e9;
        border: 1px solid #ccc;
        padding: 10px;
        border-radius: 10px;
      }
        .app-documentacao-conteudo > .solicitar > table {
          width: 100%;
        }
          .app-documentacao-conteudo > .solicitar > table > tr.campos > td {
            padding: 40px 5px 0px 5px;
          }

        .app-documentacao-conteudo > .solicitar > table > tr.botoes > td {
          text-align: center;
          padding-top: 10px;
        }
          .app-documentacao-conteudo > .solicitar > table > tr.botoes > td > button {
            margin: 5px;
          }
          
</style>

<style>
  .app-documentacao > .app-documentacao-body > .app-documentacao-top > .filtro-busca-telas > div {
    float: none
  }
  .app-documentacao > .app-documentacao-body > .app-documentacao-top > .filtro-busca-telas,
  .app-documentacao > .app-documentacao-body > .app-documentacao-top > .filtro-busca-telas > div {
    display: inline-block;

  }
  .app-documentacao > .app-documentacao-body > .app-documentacao-top > .filtro-busca-telas > div {
    float: none;
  }
    .app-documentacao > .app-documentacao-body > .app-documentacao-top > .filtro-busca-telas > div > .filtro-bt {
      margin: 0px;
      margin-top: -3px;
      margin-left: -10px;
      height: 36px;
      border-radius: 8px;
    }

  .app-documentacao-conteudo > .solicitar > table > tr.campos > td > div,
  .app-documentacao-conteudo > .solicitar > table > tr.campos > td > div > div {
    margin-bottom: 0px;
    width: 100%;
    max-width: 100%;
  }
    .app-documentacao-conteudo > .solicitar > table > tr.campos > td > div > div > input,
    .app-documentacao-conteudo > .solicitar > table > tr.campos > td > div > div > textarea {
      border: 1px solid #ccc;
      border-radius: 5px;
      font-size: 15px;
    }
    .app-documentacao-conteudo > .solicitar > table > tr.campos > td > div > div > label {
      font-weight: bold !important;
    }
</style>

<script>
  export default {
    components: {
      'RF-Filtro-Busca-Telas': () => import('@/components/rf-geral/busca/RF-Filtro-Busca-Telas.vue'),
      'RF-Rodape': () => import('@/components/rodape/Rodape.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        statusResposta: 'carregando',
        filtros: {},
        formulario: {},
        filtroBusca: '',
        dados: [],
        ids: null
      }
    },
    mounted: function () {
      this.appDocumentacaoIniciar()
    },
    methods: {
      appDocumentacaoIniciar: function () {
        // SETA O STATUS DA TELA
        this.appDocumentacaoSetaStatusGeral('carregando')

        // VERIFICA SE TEM LINK DE QRCODE PARA BUSCAR
        if ([ '', null, undefined ].indexOf(this.$route.params.qrcode) === -1) {
          this.$store.state.comunicaAPI('/subase/qrcode/get/' + this.$route.params.qrcode, 'GET', null, (retorno) => {
            // LIMMPA AS VARIAVEIS
            this.ids = JSON.parse(retorno.data.j_conteudo)

            // VERIFICA SE TEM UM VALOR VALIDO
            if ([ '', null, undefined ].indexOf(this.ids) !== -1) {
              this.ids = null
            }

            // MANDA INICIAR A TELA
            this.appDocumentacaoIniciarTela()
          }, this.appDocumentacaoSetaStatusGeral)
        } else {
          // LIMMPA AS VARIAVEIS
          this.ids = null

          // MANDA INICIAR A TELA
          this.appDocumentacaoIniciarTela()
        }
      },
      appDocumentacaoIniciarTela: function () {
        // SETA O STATUS DA TELA
        this.appDocumentacaoSetaStatusGeral('')

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(null, {
          appDocumentacaoFiltrosIniciar: [ ],
          appDocumentacaoDadosTela: [ 'appDocumentacaoFiltrosIniciar' ],
          appDocumentacaoCamposSemResultado: [ ],
          appDocumentacaoFinalizar: [ 'appDocumentacaoFiltrosIniciar', 'appDocumentacaoDadosTela' ]
        },
        {
          appDocumentacaoFiltrosIniciar: (chave, callback) => { this.appDocumentacaoFiltrosIniciar(() => { callback(chave) } ) },
          appDocumentacaoDadosTela: (chave, callback) => { this.appDocumentacaoDadosTela(() => { callback(chave) } ) },
          appDocumentacaoCamposSemResultado: (chave, callback) => { this.appDocumentacaoCamposSemResultado(() => { callback(chave) } ) },
          appDocumentacaoFinalizar: (chave, callback) => { this.appDocumentacaoFinalizar(() => { callback(chave) } ) },
        })
      },
      appDocumentacaoSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appDocumentacaoFiltrosIniciar: function (callback = null) {
        // LIMPA OS FILTROS EXISTENTES
        this.filtros = {
          status: 'carregando',
          id: 'app-documentacao',
          focus: '',
          field: {}
        }

        // SETA OS DADOS DO FILTRO BUSCA
        this.filtros.field.pacotes = {
          id: this.filtros.id + '--pacotes',
          tipo: 'select2',
          status: 'carregando',
          nome: 'Pacotes',
          value: '',
          mostrar: true,
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          optionInicialNome: 'Todos',
          options: []
        }

        // SETA OS DADOS DO FILTRO BUSCA
        this.filtros.field.tipo = {
          id: this.filtros.id + '--tipo',
          tipo: 'select2',
          status: '',
          nome: 'Tipo',
          value: 'faq',
          valueIni: 'faq',
          mostrar: true,
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          optionInicialNome: 'Todos',
          options: [
            { id: 'faq', nome: 'F.A.Q.' },
            { id: 'atualizacao', nome: 'Atualizações' }
          ]
        }
        
        // VERIFICA SE TEM ALGUMA BUSCA A SER FEITA
        if ([ '', null, undefined ].indexOf(this.$route.params.busca) === -1) {
          // PEGA O VALOR RECEBIDO NO LINK
          var vetor = JSON.parse(window.atob(this.$route.params.busca))

          // VERIFICA SE TEM ALGUMA BUSCA A SER FEITA
          if ([ null, undefined ].indexOf(vetor.busca) === -1) {
            this.filtroBusca = vetor.busca
          }

          // VERIFICA SE TEM ALGUMA BUSCA A SER FEITA
          if ([ null, undefined ].indexOf(vetor.tipo) === -1) {
            this.filtros.field.tipo.value = vetor.tipo
          }

          // VERIFICA SE TEM ALGUMA BUSCA A SER FEITA
          if ([ null, undefined ].indexOf(vetor.pacotes) === -1) {
            this.filtros.field.pacotes.value = vetor.pacotes
          }
        }

        // CHAMA A FUNÇÃO PARA BUSCAR OS PACOTES EXISTENTES
        this.appDocumentacaoFiltrosBuscarPacotes(callback)
      },
      appDocumentacaoFiltrosBuscarPacotes: function (callback = null) {
        // SETA O STATUS DO CAMPO
        this.filtros.field.pacotes.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/documentacao/pacote/get', 'GET', null, (apiSuccess) => {
          // SETA OS OPTIONS RECEBIDOS
          this.filtros.field.pacotes.options = apiSuccess.data

          // SETA O STATUS DO CAMPO
          this.filtros.field.pacotes.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }, this.appDocumentacaoSetaStatusGeral)
      },
      appDocumentacaoRealizarBusca: function (callback = null, where = null, registros = [], total = null) {
        // LIMPA OS IDS SALVOS
        this.ids = null

        // MANDA INICIAR A BUSCA
        this.appDocumentacaoDadosTela(callback, where, registros, total)
      },
      appDocumentacaoDadosTela: function (callback = null, where = null, registros = [], total = null) {
        // SETA O STATUS DE RESPOSTA
        this.statusResposta = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE JÁ TEM WHERE DA PAGINA
        if (where === null) {
          this.appDocumentacaoMontarWhere((where) => { this.appDocumentacaoDadosTela(callback, where, registros, total) })
        } else if (total === null || registros.length < total) {
          // SETA O QUERY GET QUE SERÁ REALIZADO NA PAI
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, where: where }

          // SETA OS CAMPOS
          queryGet.field = {
            id: null,
            formato: null,
            assunto: null,
            id_pac: { j: { nome: null } },
            posicao: null,
            status: null,
            tipo: null,
            created_at: null
          }

          // SETA A ORDENAÇÃO DO CAMPO
          queryGet.order = { posicao: 'asc' }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/documentacao/get/', 'GET', queryGet, (apiSuccess) => {
            // SETA OS REGISTROS RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.appDocumentacaoDadosTela(callback, where, registros, Number(apiSuccess.countAll))
          }, this.appDocumentacaoSetaStatusGeral)
        } else {
          // CHAMA A FUNÇÃO PARA LIMPAR O CAMPOS
          this.appDocumentacaoCamposLimpar()

          // MONTA O LINK DO VIDEO
          for (var index in registros) {
            // MONTA O LINK DO VIDEO
            registros[index].link = process.env.VUE_APP_S3_URI + '' + process.env.VUE_APP_BUCKET_RF + '/documentacao/' + registros[index].id

            // ALTERA O NOME DO PACOTE
            registros[index].id_pac_nome = registros[index].id_pac_nome.toLowerCase()
            registros[index].id_pac_nome = registros[index].id_pac_nome[0].toUpperCase() + registros[index].id_pac_nome.substr(1);
          }

          // VERIFICA SE TEM ALGUMA BUSCA A SER FEITA
          if (registros.length === 1 && [ '', null, undefined ].indexOf(this.$route.params.busca) === -1) {
            // PEGA O VALOR RECEBIDO NO LINK
            var vetor = JSON.parse(window.atob(this.$route.params.busca))

            // VERIFICA SE A BUSCA EXISTE
            if ([ '', null, undefined ].indexOf(vetor.busca) === -1 && vetor.busca.indexOf('id:') !== -1) {
              // PEGA O ID DO REGISTRO
              vetor.busca = vetor.busca.replace('id:', '')
              
              // VERIFICA SE DEVE ABRIR OU NÃO O VIDEO
              if (vetor.busca === registros[0].id) {
                setTimeout(() => { this.appDocumentacaoMostrarResposta(0) }, 1000)
              }
            }
          }

          // SETA OS DADOS RECEBIDOS
          this.dados = registros
          // this.dados = [ registros[0] ]
          // this.dados = this.dados.concat(JSON.parse(JSON.stringify(this.dados)))
          // this.dados = this.dados.concat(JSON.parse(JSON.stringify(this.dados)))
          // this.dados = this.dados.concat(JSON.parse(JSON.stringify(this.dados)))
          // this.dados = this.dados.concat(JSON.parse(JSON.stringify(this.dados)))

          // AGUARDA PARA APRESENTAR O CARREGANDO
          setTimeout(() => {
            // SETA O STATUS DE RESPOSTA
            this.statusResposta = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          }, 100)
        }
      },
      appDocumentacaoCamposSemResultado: function (callback = null) {
        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        this.formulario = {
          status: 'carregando',
          id: 'app-documentacao-sem-resultado--',
          field: {}
        }

        // SETA OS DADOS DA DIALOG
        this.formulario.field.nome = {
          id: this.formulario.id + 'nome',
          tipo: 'input',
          nome: 'Nome: ',
          explica: { mensagem: 'Preencha com seu nome ou nome da empresa' },
          mostrar: true,
          apiEnv: 'nome',
          onChange: this.appDocumentacaoCamposOnChange
        }
        this.formulario.field.telefone = {
          id: this.formulario.id + 'telefone',
          tipo: 'input',
          nome: 'Telefone: ',
          explica: { mensagem: 'Preencha com seu telefone' },
          mask: 'telefone',
          mostrar: true,
          apiEnv: 'telefone',
          onChange: this.appDocumentacaoCamposOnChange
        }
        this.formulario.field.email = {
          id: this.formulario.id + 'email',
          tipo: 'input',
          nome: 'E-mail: ',
          explica: { mensagem: 'Preencha com seu e-mail, para possivelmente receber uma resposta.' },
          mostrar: true,
          apiEnv: 'email',
          onChange: this.appDocumentacaoCamposOnChange
        }
        this.formulario.field.descricao = {
          id: this.formulario.id + 'descricao',
          tipo: 'textarea',
          nome: 'Descrição: ',
          // explica: { mensagem: 'Descreva o máximo possivel da sua dúvida, para que possamos analisar e possivelmente lhe responder.' },
          placeholder: 'Descreva o máximo possível da sua dúvida, para que possamos analisar e possivelmente responder.',
          mostrar: true,
          apiEnv: 'duvida',
          onChange: this.appDocumentacaoCamposOnChange
        }

        // CHAMA A FUNÇÃO PARA MONTAR OS CAMPOS INICIAIS
        this.$store.state.FUN_CREATE_KEY_FIELDS(this.formulario.field, (fields) => {
          // SETA OS CAMPOS RECEBIDOS
          this.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CRIA OS BUTTONS
          this.$store.state.FUN_CREATE_BUTTON_FORM(this.formulario.id, [ 0 ], null, {
            env: this.appDocumentacaoCamposEnviarEmail
          }, (buttons) => {
            // CRIA OS BUTTONS DO FORMULARIO
            this.formulario.buttons = buttons

            // SETA O STATUS DO BUTTON
            this.formulario.buttons.env.texto = 'Enviar'

            // LIMPA O STATUS DO FORMULARIO
            this.formulario.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          })
        })
      },
      appDocumentacaoCamposOnChange: function (value, id) {
        // PEGA O CAMPO QUE DEVE SER ATUALIZADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.formulario.field[index[1]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index[1]].mensagem = ''
        this.formulario.field[index[1]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appDocumentacaoCamposEnviarEmail: function () {
        // SETA O STATUS DO BUTTON
        this.formulario.buttons.env.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // MONTA O FORMULARIO PARA ENVIAR PARA API
        this.$store.state.FUN_CREATE_FORM_API_FORMULARIO(this.formulario.field, {}, (formData) => { 
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/documentacao/duvida', 'POST', formData, (apiSuccess) => {
            // APRESENTA A MENSAGEM RETORNADA DA API
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // // CHAMA A FUNÇÃO PARA LIMPAR O CAMPOS
            // this.appDocumentacaoCamposLimpar()

            // // SETA O STATUS DO BUTTON
            // this.formulario.buttons.env.status = ''

            // // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            // this.time = new Date().getTime()
          }, this.appDocumentacaoSetaStatusGeral, (apiValid, apiStatus) => {
            this.$store.state.FUN_API_RET_VALIDA(this, 'formulario', apiValid, apiStatus, this.formulario.field, true, () => {
              // SETA O STATUS DO BUTTON
              this.formulario.buttons.env.status = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          })
        })
      },
      appDocumentacaoCamposLimpar: function () {
        // LIMPA O VALOR DE TODOS OS CAMPOS
        for (var indexF in this.formulario.field) {
          this.formulario.field[indexF].value = ''
        }

        // SETA O STATUS DO BUTTON
        if ([ '', null, undefined ].indexOf(this.formulario.buttons) === -1 && [ '', null, undefined ].indexOf(this.formulario.buttons.env) === -1) {
          this.formulario.buttons.env.status = ''
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appDocumentacaoFinalizar: function (callback = null) {
        // SETA O VALOR INICIAL DO CAMPO
        this.filtros.field.tipo.valueIni = ''

        // SETA O STATUS DA TELA
        this.appDocumentacaoSetaStatusGeral('')
        // SETA O FLAG HOUVE ALTERAÇÃO NOS FILTROS
        setTimeout(() => { this.$refs.filtros.filtrado = true }, 500)


        // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      appDocumentacaoMontarWhere: function (callback = null) {
        // MONTA O VALOR DO WHERE
        var where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }
        
        // VERIFICA OS IDS QUE DEVE BUSCAR
        if ([ '', null, undefined ].indexOf(this.ids) === -1) {
          // FAZ A BUSCA DOS DADOS NA API
          where.aAnd.push({ f: 'id', o: 'in', v: this.ids.join() })

          // RETORNA O VALOR MONTADO
          callback(where)
        } else {
          // SETA A FUNÇÃO PARA FINALIZAR O CARREGAMENTO DOS FILTROS
          var finalizar = (filtros) => {
            // VERIFICA SE TEM QUE BUSCAR ALGUMA COISA
            if ([ '', null, undefined ].indexOf(this.filtroBusca) === -1) {
              if (this.filtroBusca.substring(0, 3) === 'id:') {
                where.aAnd.push({ f: 'id', o: 'in', v: this.filtroBusca.substring(3, this.filtroBusca.length) })
              } else {
                where.aAnd.push({ o: 's.ft', v: this.filtroBusca })
              }
            }
  
            // VERIFICA SE TEM QUE SETAR O FILTRO DE PACOTES
            if ([ '', null, undefined ].indexOf(filtros.pacotes) === -1) {
              where.aAnd.push({ f: 'id_pac', o: 'in', v: filtros.pacotes })
            }
  
            // VERIFICA SE TEM QUE SETAR O FILTRO DE TIPO
            if ([ '', null, undefined ].indexOf(filtros.tipo) === -1) {
              where.aAnd.push({ f: 'tipo', o: 'in', v: filtros.tipo })
            }
  
            // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
            if (callback !== null && typeof callback === 'function') {
              callback(where)
            }
          }
  
          // VERIFICA SE EXISTE OS FILTROS NA TELA
          switch ([ '', null, undefined ].indexOf(this.$refs.filtros) !== -1 || [ '', null, undefined ].indexOf(this.$refs.filtros.appCapturarFiltrosSelecionados) !== -1) {
            case true:
              finalizar({})
              break
  
            default:
              this.$refs.filtros.appCapturarFiltrosSelecionados((filtros) => { finalizar(filtros) })
              break
          }
        }

      },
      appDocumentacaoMostrarResposta: function (indexV) {
        if ([ '', null, undefined ].indexOf(this.dados[indexV]) === -1) {
          if (this.dados[indexV].formato === 'pdf') {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', this.dados[indexV].link, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
              if (this.status == 200) {
                var myBlob = this.response;
                // / CRIE O OBJETO BLOB COM O CONTENT-TYPE "APPLICATION/PDF"
                var blob = new Blob([ myBlob ], { type: "application/pdf" })
                var url = URL.createObjectURL(blob)

                // MANDA ABRIR O BLOB
                window.open(url, '_blank')
              }
            }
            xhr.send()
          } else {  
            // SETA SE DEVE OU NÃO MOSTRAR O VIDEO
            this.dados[indexV].mostrar = this.dados[indexV].mostrar === true ? false : true
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // SETA A CHAVE QUE SERÁ UTILIZADA
            var chave = 'video-' + indexV
  
            // VERIFICA SE O VETOR DEVE CARREGAR
            setTimeout(() => {
              if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
                switch (this.dados[indexV].mostrar) {
                  case true:
                    // this.$refs[chave][0].play()
                    break
  
                  default:
                    this.$refs[chave][0].pause()
                    break
                }
              }
            }, ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 ? 0 : 1000))
          }
        }
      },
      appDocumentacaoCopiarLink: function (indexV) {
        // SETA O VETOR QUE SERÁ COLOCADO NO LINK
        var vetor = { busca: 'id:' + this.dados[indexV].id, tipo: '', pacotes: '' }

        // MONTA O LINK QUE DEVE COPIAR
        var link = process.env.VUE_APP_URL_WEB + '/documentacao/' + window.btoa(JSON.stringify(vetor))

        // COPIA O LINK PARA AREA DE TRANSFERENCIA
        this.$store.commit('FUN_COPIAR_VALOR', { valor: link, mensagem: 'WEB [200]: Link copiado para a área de transferência.' })
      }
    }
  }
</script>
